import { useLocation, useNavigate } from "react-router-dom";

import ViewTab from "components/atoms/ViewTab";
import { Tab, UserPermissions } from "utils/enums";

import { useSelectedBuildingModelCarbonReductionPlan } from "hooks/Building/useBuildingModelCarbonReductionPlan";
import { usePermissions } from "hooks/usePermissions";

import { useFeatureFlagEnabled } from "posthog-js/react";

import "./BuildingPage.scss";
import PublishPlanButton from "./CustomPlan/Header/PublishPlanButton";
import RemodelPlanButton from "./CustomPlan/Header/RemodelPlanButton";
import RenamePlanButton from "./CustomPlan/Header/RenamePlanButton";
import ReportPlanButton from "./CustomPlan/Header/ReportPlanButton";
import styles from "./ViewTabs/ViewTabs.module.scss";

function BuildingPageTabs() {
    const location = useLocation();
    const pathParts = location.pathname.split("/");
    const currentActiveTab = pathParts[6] as Tab;
    const navigate = useNavigate();
    const { bmcrp: selectedBMCRP } = useSelectedBuildingModelCarbonReductionPlan();
    const outcomesV1Enabled = useFeatureFlagEnabled("new-outcomes-page-for-building");
    const { hasPermission } = usePermissions();

    return (
        <div style={{ display: "flex" }}>
            <div className={styles.viewTabs}>
                {hasPermission(UserPermissions.UseInternalTools) && (
                    <ViewTab // TODO: change to ViewPlanSettings
                        id="building-settings-tab"
                        name="Settings"
                        selected={currentActiveTab === Tab.Settings}
                        onClick={() => navigate(Tab.Settings)}
                    />
                )}
                <ViewTab
                    id="building-baseline-tab"
                    name="Baseline"
                    selected={currentActiveTab === Tab.Baseline}
                    onClick={() => navigate(Tab.Baseline)}
                />
                <ViewTab
                    id="building-plan-tab"
                    name="Outcomes"
                    selected={currentActiveTab === Tab.Outcomes}
                    onClick={() => navigate(Tab.Outcomes)}
                />
                <ViewTab
                    id="building-recommendations-tab"
                    name="Measures"
                    selected={currentActiveTab === Tab.Measures}
                    onClick={() => navigate(Tab.Measures)}
                />
                {outcomesV1Enabled && (
                    <ViewTab
                        id="building-outcomes-tab"
                        name="Outcomes-V1"
                        selected={currentActiveTab === Tab.OutcomesV1}
                        onClick={() => navigate(Tab.OutcomesV1)}
                    />
                )}
            </div>
            <div
                style={{
                    marginRight: 30,
                    marginLeft: "auto",
                    display: "flex",
                    gap: "0.5rem",
                    flexWrap: "nowrap",
                    overflowX: "auto",
                }}
            >
                {selectedBMCRP && <PublishPlanButton buildingModelCarbonReductionPlan={selectedBMCRP} />}
                {selectedBMCRP && <RemodelPlanButton buildingModelCarbonReductionPlan={selectedBMCRP} />}
                {selectedBMCRP && <RenamePlanButton buildingModelCarbonReductionPlan={selectedBMCRP} />}
                {selectedBMCRP && <ReportPlanButton buildingModelCarbonReductionPlan={selectedBMCRP} />}
            </div>
        </div>
    );
}

export default BuildingPageTabs;
